import { Immutable } from "immer";

export type tSalesExcelFormat = {
  "Order #": string;
  "Order Date": string;
  "Approved Date": string;
  "Brand Name": string;
  "Business Name": string;
  Source: string;
  "Order Status": string;
  "Order Total": string;
  "Shipping Total": string;
  "Main Tab Commission": string;
  "Sales Rep Name (if applicable)": string;
  "Sales Rep Commission": string;
  "TMT Transaction fee": string;
  "Ship to Address": string;
  "Ship to City": string;
  "Ship to State": string;
  "Ship to Zip": string;
  "PO # if applicable": string;
  "Promotion code (if applicable)": string;
  "Promotion discount $ value (if applicable)": string;
};

export type tSalesSKUExcelFormat = {
  "Order Date": string;
  "Order Number": string;
  "Business Name": string;
  "Brand Name": string;
  "Address 1": string;
  "Address 2": string;
  City: string;
  State: string;
  "Zip Code": string;
  Country: string;
  "Product Name": string;
  SKU: string;
  Quantity: string;
  "Wholesale Price": string;
  "Retail Price": string;
  "Order Source": string;
  "Order Status": string;
  "Sales Rep Name (if applicable)": string;
};

export type tBrandExcelFormat = {
  "Approved Date": string;
  "Brand Name": string;
  Commission: string;
  "TMT Transaction fee": string;
  Exclusive: string;
  "Contact Name": string;
  "Contact Email": string;
  Website: string;
  "Ship to Address": string;
  "Ship to City": string;
  "Ship to State": string;
  "Ship to Zip": string;
  Category: string;
  "What Retail price points are your products?": string;
  About: string;
};

export type tRetailerExcelFormat = {
  "Activated Date": string;
  "Business Name": string;
  "Contact Name": string;
  "Contact Email": string;
  Website: string;
  "Store Type": string;
  "Ship to Address": string;
  "Ship to City": string;
  "Ship to State": string;
  "Ship to Zip": string;
  "Category that best describes your store": string;
  "Average Retail Price Point of your Brands": string;
  "How many retail locations do you have?": string;
  About: string;
};

export type tConnectionRequestExcelFormat = {
  "Connection Request Date": string;
  "Connection Status": string;
  "Business Name": string;
  "Brand Name": string;
  "Rep Assigned": string;
  "Rep Commission": string;
  Shipping: string;
};

export type tBrandInvitingRetailerExcelFormat = {
  "Invite Date": string;
  "Brand Name": string;
  "E-mail Address": string;
  "Email note": string;
};

export type tNewProductsExcelFormat = {
  Date: string;
  "Brand Name": string;
  "Product Name": string;
  "Wholesale Price": string;
  "Retail Price": string;
  Status: string;
  Inventory: string;
};

type tReportRecord<N, T> = { myName: N; myJSON: T[] };
type tSalesReport = tReportRecord<"TotalSales", tSalesExcelFormat>;
type tSalesSKUReport = tReportRecord<"TotalSKUs", tSalesSKUExcelFormat>;
type tBrandReport = tReportRecord<"Brands", tBrandExcelFormat>;
type tRetailerReport = tReportRecord<"Retailers", tRetailerExcelFormat>;
type tConnectionReport = tReportRecord<"Connections", tConnectionRequestExcelFormat>;
type tBrandInviteReport = tReportRecord<"BrandInvites", tBrandInvitingRetailerExcelFormat>;
type tNewProductReport = tReportRecord<"NewProducts", tNewProductsExcelFormat>;
// type tReportType = "TotalSales" | "TotalSKUs" | "Retailers" | "Connections" | "BrandInvites" | "NewProducts";
type tReport = {
  TotalSales?: tSalesReport;
  TotalSKUs?: tSalesSKUReport;
  Brands?: tBrandReport;
  Retailers?: tRetailerReport;
  Connections?: tConnectionReport;
  BrandInvites?: tBrandInviteReport;
  NewProducts?: tNewProductReport;
};
export type tReportResponse = { downloadURL?: string; reportJSON: tReport };

export const kMonth = 2629800000; // a month ago
export const kYear = kMonth * 12; // a year ago
export const kDefaultStartOffset = kMonth;

export type tAdminState = {
  loading: boolean;
  downloadURL?: string;
  reportJSON: tReport;
  startDate: number;
  endDate: number;
  salesIncluded: boolean;
  brandsIncluded: boolean;
  retailersIncluded: boolean;
  connectionsIncluded: boolean;
  productsIncluded: boolean;
};

export type tAdminStateImmutable = Immutable<tAdminState>;

export type tFetchingAdminReport = {
  type: "FETCHING_ADMIN_REPORT";
};

export type tUpdateReport = {
  type: "SET_ADMIN_REPORT";
  downloadURL?: string;
  reportJSON: tReport;
};

export type tSetReportOptions = {
  type: "SET_REPORT_OPTIONS";
  startDate?: number;
  endDate?: number;
  salesIncluded?: boolean;
  brandsIncluded?: boolean;
  retailersIncluded?: boolean;
  connectionsIncluded?: boolean;
  productsIncluded?: boolean;
};

export type tAdminAction = tFetchingAdminReport | tUpdateReport | tSetReportOptions;
